import { type FunctionComponent } from 'react';

import { LoadingSpinner } from '@kanda-libs/ks-design-library';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const CardPaymentFormLoader: FunctionComponent = () => (
  <div className="m-auto">
    <PleaseWaitOverlay
      icon="check-circle-color"
      title="We're just loading your payment link"
      labelLine1="This should only take a few seconds. If this is taking too long, please refresh your page"
    />
    <LoadingSpinner size={50} stroke="purple-400" className="mx-auto mt-6" />
  </div>
);

export default CardPaymentFormLoader;
